import {useState} from 'react'
import setQueryParam from '@packages/justo-parts/lib/helpers/setQueryParam'
import {useApolloQuery} from 'apollo-hooks'
import {useRouter} from 'next/router'

export interface UsePaginationOpts {
  query: any
  params?: any
  variables?: any
  fields?: Array<any>
  initialLimit?: number
  initialPage?: number
}

/**
 * Pagination abstraction.
 */
export default function usePagination({
  query,
  variables,
  initialLimit = 10,
  initialPage = 1
}: UsePaginationOpts) {
  const router = useRouter()
  const [page, setInternalPage] = useState(Number(router.query.page) || initialPage)
  const [limit, setInternalLimit] = useState(Number(router.query.limit) || initialLimit)

  const {data} = useApolloQuery({
    query,
    variables: {page, limit, ...variables}
  })

  const setPage = val => {
    setInternalPage(val)
    setQueryParam('page', val)
  }

  const setLimit = val => {
    setInternalLimit(val)
    setQueryParam('limit', val)
  }

  return {data, page, setPage, limit, setLimit}
}
